import React, { useContext, useState } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import "./Product.css";
import { BsFillBookmarkFill } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";
import { BsBookmark } from "react-icons/bs";
import UserComment from "../../Components/UserComment/UserComment";
import UserPanelEmptyAlert from "../../Components/UserPanelEmptyAlert/UserPanelEmptyAlert";
import { CiImageOff } from "react-icons/ci";
import { ToastContainer, toast } from "react-toastify";
import { addToBasket } from "../../Helpers/basketHelper";
import Swal from "sweetalert2";
import { CartContext } from "../../Hooks/CartContext";
import { Helmet } from "react-helmet-async";

export default function Product() {
    const [counter, setCounter] = useState(1);
    const { cartItems, addToCart } = useContext(CartContext);
    const [showProductTab, setShowProductTab] = useState("info");
    const param = useParams('title');
    const nav = useNavigate();
    const [productData, setProductData] = useState({
        productImages: [],
        isSaved: false,
        id: "",
    });
    const currentDate = new Date();
    useEffect(() => {
        axiosConfig
            .get(
                "/api/Products/" +
                param.title +
                "?userId=" +
                localStorage.getItem("userId")
            )
            .then((res) => {
                setProductData(res.data);
            });
    }, [param]);

    function saveProduct() {
        axiosConfig
            .post("api/products/productSave/" + productData.id)
            .then((result) => {
                toast.success("با موفقیت محصول سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setProductData({ ...productData, isSaved: true });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }
    function deleteSaveProduct() {
        axiosConfig
            .delete("api/products/ProductSave/" + productData.id)
            .then((result) => {
                toast.success("با موفقیت محصول سیود شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setProductData({ ...productData, isSaved: false });
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    nav("/login");
                }
            });
    }

    const addToBasketHandler = async () => {
        if (counter === 0) {
            Swal.fire("خطا", "تعداد درخواستی نمیتواند 0 باید", "error");
            return;
        }

        const res = await addToBasket(productData.id, 1, counter);
        if (res) addToCart(cartItems + counter)

        setCounter(1);
    };

    return (
        <>

            <Helmet>
                <title>سه نیک | {productData?.title}</title>
                <meta
                    name="description"
                    content={productData.summary?.slice(0, 160) || 'مشاهده جزئیات '}
                />
            </Helmet>
            <div className="product-section">
                <Container>
                    <div className="product-Introduction">
                        <Row className="product-Introduction-row">
                            <Col lg={5}>
                                <div className="produc-Introduction-image">
                                    {productData.productImages.length ? (
                                        <img
                                            src={
                                                axiosConfig.defaults.baseURL +
                                                "Images/ProductImage/" +
                                                productData.id +
                                                "/" +
                                                productData.productImages[0]
                                                    .imagePath
                                            }
                                            alt={productData.title}
                                        />
                                    ) : (
                                        <img src={ImageNotFound} alt={productData.title} />
                                    )}
                                </div>
                            </Col>
                            <Col lg={7}>
                                <div className="produc-Introduction-left">
                                    <h1>{productData.title}</h1>
                                    <h3>{productData?.count == 0 ? (
                                        <span style={{ color: "red" }}>ناموجود</span>
                                    ) : (
                                        <span style={{ color: "green" }}>موجود</span>
                                    )}</h3>
                                    {productData.discount != null && new Date(productData.discount.startTime).getTime() >= currentDate.getTime()
                                        && new Date(productData.discount.startTime).getTime() <=
                                        currentDate.setDate(currentDate.getDate() + parseInt(productData.discount.duration)) ? (
                                        <div className="produc-Introduction-left-price">
                                            <span className="produc-Introduction-left-prev-price">
                                                {productData.price?.toLocaleString(
                                                    "fa-IR"
                                                )}
                                            </span>
                                            <span className="produc-Introduction-left-current-price">
                                                {(
                                                    productData.price -
                                                    (productData.price *
                                                        productData.discount
                                                            .percent) /
                                                    100
                                                ).toLocaleString("fa-IR")}
                                                <span>تومان</span>
                                            </span>
                                        </div>
                                    ) : (
                                        productData.price == 0 ? (
                                            <div className="produc-Introduction-left-price">
                                                <span className="produc-Introduction-left-current-price" style={{ color: "green" }}>
                                                    رایگان
                                                </span>
                                            </div>
                                        ) : (
                                            <div className="produc-Introduction-left-price">
                                                <span className="produc-Introduction-left-current-price">
                                                    {productData.price?.toLocaleString(
                                                        "fa-IR"
                                                    )}
                                                    <span>تومان</span>
                                                </span>
                                            </div>
                                        )
                                    )}
                                    <div className="produc-Introduction-left-btns">
                                        <div className="produc-Introduction-count-btns">
                                            <button
                                                onClick={() =>
                                                    setCounter((prev) => {
                                                        if (prev !== 0) {
                                                            return prev - 1;
                                                        } else {
                                                            return prev;
                                                        }
                                                    })
                                                }
                                            >
                                                -
                                            </button>
                                            <button>{counter}</button>
                                            <button
                                                onClick={() =>
                                                    setCounter(counter + 1)
                                                }
                                            >
                                                +
                                            </button>
                                        </div>
                                        <div></div>
                                        <button
                                            onClick={() => {
                                                addToBasketHandler();
                                            }}
                                            className="produc-Introduction-add-to-cart"
                                        >
                                            افزودن به سبد خرید
                                        </button>
                                        {productData.isSaved == true ? (
                                            <BsFillBookmarkFill
                                                onClick={deleteSaveProduct}
                                                className="produc-Introduction-bookmark"
                                            />
                                        ) : (
                                            <BsBookmark
                                                onClick={saveProduct}
                                                className="produc-Introduction-bookmark"
                                            />
                                        )}
                                    </div>

                                    <div className="produc-Introduction-category">
                                        <Link to={"/search/all/" + productData.category?.title}>
                                            <span>
                                                {productData.category?.title}
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <div className="produc-Introduction-left"></div>
                            </Col>
                        </Row>
                        <div className="product-Introduction-bottom">
                            <div className="product-Introduction-bottom-header">
                                <button
                                    className={
                                        showProductTab === "info"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => setShowProductTab("info")}
                                >
                                    اطلاعات محصول
                                </button>
                                <button
                                    className={
                                        showProductTab === "img" ? "active" : ""
                                    }
                                    onClick={() => setShowProductTab("img")}
                                >
                                    عکس های محصول
                                </button>
                                <button
                                    className={
                                        showProductTab === "comment"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => setShowProductTab("comment")}
                                >
                                    نظرات کاربران
                                </button>
                            </div>
                            {showProductTab === "info" ? (
                                <>
                                    <div
                                        className="product-Introduction-bottom-content"
                                        dangerouslySetInnerHTML={{
                                            __html: productData.summary,
                                        }}
                                    ></div>
                                    <div>
                                        <Table striped bordered hover size="sm">
                                            <thead></thead>
                                            <tbody>
                                                {productData.fieldValues?.map(
                                                    (item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    item.field
                                                                        ?.title
                                                                }
                                                            </td>
                                                            <td>
                                                                {item.value}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </>
                            ) : showProductTab === "img" ? (
                                <div className="product-Introduction-bottom-content">
                                    <div className="product-Introduction-product-image">
                                        <Row>
                                            {productData.productImages
                                                .length ? (
                                                productData.productImages.map(
                                                    (image, index) => (
                                                        <Col lg={4} key={index}>
                                                            <img
                                                                src={
                                                                    axiosConfig
                                                                        .defaults
                                                                        .baseURL +
                                                                    "Images/ProductImage/" +
                                                                    productData.id +
                                                                    "/" +
                                                                    image.imagePath
                                                                }
                                                                alt=""
                                                            />
                                                        </Col>
                                                    )
                                                )
                                            ) : (
                                                <UserPanelEmptyAlert
                                                    title="عکسی برای این محصول وجود ندارد"
                                                    icon={<CiImageOff />}
                                                />
                                            )}
                                        </Row>
                                    </div>
                                </div>
                            ) : showProductTab === "comment" ? (
                                <div className="product-Introduction-bottom-comment">
                                    <UserComment itemId={productData.id} />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Container>
            </div>
            <ToastContainer />

        </>
    );
}
